module.exports = __webpack_public_path__ + "pc/img/wx.28814eb4.png";